import * as React from "react";
import { Checkbox } from "src/share/components/Checkbox/Checkbox";

const ChildSelector = ({ child, isChildSelected, onChildSelected }) => {
  return (
    <div key={child.id} className="child-selector">
      <Checkbox disabled={false} label={child.name} checked={isChildSelected} onChange={() => onChildSelected(child.id)} />
      <div className="child-selector--images">
        {child.images.map((image, index) => (image ? <img key={index} src={image} className="child-selector--child-image" /> : null))}
      </div>
    </div>
  );
};

export default ChildSelector;



// WEBPACK FOOTER //
// ./src/modules/GeoSearch/Search/components/ChildSelector.tsx